import { useMutation } from "@tanstack/react-query";
import { APIs } from "../api/APIs";
import { api } from "../api";

export const useAuth = () => {
  const checkUserIdMutation = useMutation({
    mutationFn: async (keys) => {
      const api_info = APIs.auth_user.check_user_id(keys);
      const response = await api(api_info);
      return response.data;
    },
  });

  const checkEmailMutation = useMutation({
    mutationFn: async (keys) => {
      const api_info = APIs.auth_user.check_email(keys);
      const response = await api(api_info);
      return response.data;
    },
  });

  const confirmEmailMutation = useMutation({
    mutationFn: async (keys) => {
      const api_info = APIs.auth_user.confirm_email(keys);
      const response = await api(api_info);
      return response.data;
    },
  });

  const signUpMutation = useMutation({
    mutationFn: async (keys) => {
      const api_info = APIs.auth_user.sign_up(keys);
      const response = await api(api_info);
      return response.data;
    },
  });

  const signInMutation = useMutation({
    mutationFn: async (keys) => {
      const api_info = APIs.auth_user.sign_in(keys);
      const response = await api(api_info);
      return response.data;
    },
  });

  const findIdMutation = useMutation({
    mutationFn: async (keys) => {
      const api_info = APIs.auth_user.find_id(keys);
      const response = await api(api_info);
      return response.data;
    },
  });

  const findPasswordByEmailMutation = useMutation({
    mutationFn: async (keys) => {
      const api_info = APIs.auth_user.find_password_by_email(keys);
      const response = await api(api_info);
      return response.data;
    },
  });

  const resetPasswordByEmailMutation = useMutation({
    mutationFn: async (keys) => {
      const api_info = APIs.auth_user.reset_password_by_token(keys);
      const response = await api(api_info);
      return response.data;
    },
  });

  return {
    checkUserIdMutation,
    checkEmailMutation,
    confirmEmailMutation,
    signUpMutation,
    signInMutation,
    findIdMutation,
    findPasswordByEmailMutation,
    resetPasswordByEmailMutation,
  };
};
